export const HandMoneyIcon = () => (
    <svg
        fill="none"
        height="335"
        viewBox="0 0 388 335"
        width="388"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M129.492 151.162C171.186 151.162 204.985 117.363 204.985 75.6699C204.985 33.9766 171.186 0.177429 129.492 0.177429C87.7991 0.177429 54 33.9766 54 75.6699C54 117.363 87.7991 151.162 129.492 151.162Z"
            fill="#EFD90F"
        />
        <path
            d="M204.979 75.6706C204.979 79.2232 204.729 82.7257 204.247 86.1453C199.638 119.449 173.282 145.805 139.97 150.431C136.542 150.905 133.048 151.155 129.487 151.155C122.432 151.155 115.594 150.182 109.113 148.368L160.211 6.69305C186.593 18.4568 204.979 44.9132 204.979 75.6706Z"
            fill="#F3E82E"
        />
        <path
            d="M204.247 86.1452C199.638 119.449 173.282 145.805 139.97 150.431C144.587 117.119 170.935 90.7618 204.247 86.1452Z"
            fill="#EFBD0C"
        />
        <path
            d="M220.551 242.221C262.244 242.221 296.043 208.421 296.043 166.728C296.043 125.035 262.244 91.2355 220.551 91.2355C178.857 91.2355 145.058 125.035 145.058 166.728C145.058 208.421 178.857 242.221 220.551 242.221Z"
            fill="#EFD90F"
        />
        <path
            d="M296.038 166.729C296.038 170.54 295.755 174.275 295.214 177.936C290.339 210.657 264.481 236.523 231.752 241.382C228.099 241.931 224.356 242.213 220.545 242.213C213.49 242.213 206.652 241.24 200.171 239.426L251.269 97.7518C277.651 109.514 296.038 135.971 296.038 166.729Z"
            fill="#F3E82E"
        />
        <path
            d="M295.214 177.935C290.339 210.655 264.481 236.521 231.752 241.38C236.619 208.651 262.493 182.786 295.214 177.935Z"
            fill="#EFBD0C"
        />
        <path
            d="M388 258.693C388 300.383 354.206 334.177 312.508 334.177C305.453 334.177 298.615 333.204 292.134 331.391C260.344 322.505 237.024 293.32 237.024 258.694C237.024 216.996 270.818 183.202 312.508 183.202C323.449 183.202 333.848 185.523 343.232 189.716C369.614 201.479 388 227.935 388 258.693Z"
            fill="#EFD90F"
        />
        <path
            d="M388 258.693C388 300.383 354.206 334.177 312.508 334.177C305.453 334.177 298.615 333.204 292.134 331.391L343.232 189.716C369.614 201.479 388 227.935 388 258.693Z"
            fill="#F3E82E"
        />
        <path
            d="M325.164 230.14H305.056V252.978H318.75V265.457H305.056V287.239H332.519V299.718H279.057V287.239H292.577V265.457H279.057V252.978H292.577V217.661H337.644V244.725H325.164V230.14Z"
            fill="#EFBD0C"
        />
        <path
            d="M230.67 148.251V138.176H211.261V149.333H223.881V161.812H211.261V171.646H223.881V184.125H211.261V195.282H230.67V186.262H243.15V207.761H198.781V184.125H188.931V171.646H198.781V161.812H188.931V149.333H198.781V125.697H243.15V148.251H230.67Z"
            fill="#EFBD0C"
        />
        <path
            d="M115.277 57.101V69.4309H156.185V106.72H135.727V120.887H123.248V106.72H102.798V94.2402H143.705V81.9102H102.798V44.621H123.248V30.4449H135.727V44.621H156.185V57.101H115.277Z"
            fill="#EFBD0C"
        />
        <path
            d="M156.185 44.6209V57.1009H142.033L146.534 44.6209H156.185Z"
            fill="#EFD90F"
        />
        <path
            d="M156.185 69.4308V106.719H135.727V120.887H123.248V109.174L128.639 94.2401H143.705V81.9102H133.081L137.582 69.4308H156.185Z"
            fill="#EFD90F"
        />
        <path
            d="M223.881 184.125H220.113L223.881 173.684V184.125Z"
            fill="#EFD90F"
        />
        <path
            d="M243.15 125.697V148.251H233.058L241.186 125.697H243.15Z"
            fill="#EFD90F"
        />
        <path
            d="M230.67 186.262H243.15V207.761H211.593L216.094 195.282H230.67V186.262Z"
            fill="#EFD90F"
        />
        <path
            d="M318.75 265.457H315.913L318.75 257.603V265.457Z"
            fill="#EFD90F"
        />
        <path
            d="M308.059 287.239H332.519V299.718H303.559L308.059 287.239Z"
            fill="#EFD90F"
        />
        <path
            d="M337.644 217.661V244.725H325.164V239.817L333.152 217.661H337.644Z"
            fill="#EFD90F"
        />
        <path d="M50 202.429H0V331H50V202.429Z" fill="#9169F6" />
        <path
            d="M25.0001 313.143C32.8899 313.143 39.2858 306.747 39.2858 298.857C39.2858 290.967 32.8899 284.571 25.0001 284.571C17.1103 284.571 10.7144 290.967 10.7144 298.857C10.7144 306.747 17.1103 313.143 25.0001 313.143Z"
            fill="#D8A852"
        />
        <path
            d="M185.714 223.857C185.714 215.968 179.318 209.571 171.429 209.571H139.286H128.571H115.707L119.236 193.075C121.929 180.489 121.207 165.15 119.607 154.375C118.007 143.6 108.357 131 98.2607 131H97.4071C88.8 131 85.7143 140.496 85.7143 152.429C85.7143 210.464 57.1429 209.571 57.1429 209.571H50V323.857H103.571H139.286H153.571C161.461 323.857 167.857 317.461 167.857 309.571C167.857 301.682 161.461 295.286 153.571 295.286H164.286C172.175 295.286 178.571 288.889 178.571 281C178.571 273.111 172.175 266.714 164.286 266.714H175C182.889 266.714 189.286 260.318 189.286 252.429C189.286 243.525 183.525 240.136 175 238.871C170.846 238.254 163.3 238.143 160.714 238.143H171.429C179.318 238.143 185.714 231.746 185.714 223.857Z"
            fill="#FBCE9D"
        />
        <path
            d="M180.786 234.571H135.714C133.743 234.571 132.143 236.168 132.143 238.143C132.143 240.118 133.743 241.714 135.714 241.714H183.771C181.425 240.275 178.457 239.382 175 238.871C170.846 238.254 163.3 238.143 160.714 238.143H171.429C175.029 238.143 178.275 236.768 180.786 234.571Z"
            fill="#F7B563"
        />
        <path
            d="M184.357 263.143H135.714C133.743 263.143 132.143 264.739 132.143 266.714C132.143 268.689 133.743 270.286 135.714 270.286H173.646C171.136 268.089 167.886 266.714 164.286 266.714H175C178.6 266.714 181.846 265.339 184.357 263.143Z"
            fill="#F7B563"
        />
        <path
            d="M173.643 291.714H128.571C126.6 291.714 125 293.311 125 295.286C125 297.261 126.6 298.857 128.571 298.857H162.932C160.421 296.661 157.171 295.286 153.571 295.286H164.286C167.886 295.286 171.132 293.911 173.643 291.714Z"
            fill="#F7B563"
        />
    </svg>
);
export const AngleUpIcon = () => (
    <svg
        fill="none"
        height="10"
        viewBox="0 0 16 10"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 8.17749L8 1.17749L15 8.17749"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);
export const AngleDownIcon = () => (
    <svg
        fill="none"
        height="10"
        viewBox="0 0 16 10"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15 1.17743L8 8.17743L1 1.17743"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);
export const MailIcon = ({ width, height }) => (
    <svg
        fill="none"
        height={height}
        viewBox="0 0 18 15"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.52344 3.84409L8.09844 8.22742C8.37232 8.41015 8.69419 8.50767 9.02344 8.50767C9.35268 8.50767 9.67455 8.41015 9.94844 8.22742L16.5234 3.84409M3.1901 13.0108H14.8568C15.2988 13.0108 15.7227 12.8352 16.0353 12.5226C16.3478 12.21 16.5234 11.7861 16.5234 11.3441V3.01075C16.5234 2.56872 16.3478 2.1448 16.0353 1.83224C15.7227 1.51968 15.2988 1.34409 14.8568 1.34409H3.1901C2.74808 1.34409 2.32415 1.51968 2.01159 1.83224C1.69903 2.1448 1.52344 2.56872 1.52344 3.01075V11.3441C1.52344 11.7861 1.69903 12.21 2.01159 12.5226C2.32415 12.8352 2.74808 13.0108 3.1901 13.0108Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);
export const ForbidIcon = () => (
    <svg
        fill="none"
        height="102"
        viewBox="0 0 80 102"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M43.977 17.5236V44.6851C43.977 46.1361 42.7964 47.3136 41.3417 47.3136C39.8871 47.3136 38.7065 46.1361 38.7065 44.6851V5.25707C38.7065 2.35342 36.347 0 33.4359 0C30.5248 0 28.1653 2.35342 28.1653 5.25707V44.6851C28.1653 46.1361 26.9847 47.3136 25.53 47.3136C24.0754 47.3136 22.8948 46.1361 22.8948 44.6851V13.1427C22.8948 10.7227 20.9288 8.76178 18.5026 8.76178C16.0764 8.76178 14.1105 10.7227 14.1105 13.1427V48.1898C14.1105 49.6408 12.9299 50.8183 11.4752 50.8183C10.0205 50.8183 8.83993 49.6408 8.83993 48.1898V26.2854C8.83993 23.8653 6.87401 21.9045 4.44779 21.9045H4.43022C2.00401 21.9045 0.0380859 23.8653 0.0380859 26.2854V73.8233C1.50682 94.9918 13.1442 100 29.5708 100C41.2838 100 51.3839 94.0262 56.2346 85.3661C58.2743 82.0821 70.6303 62.8921 71.6914 60.8874C72.9282 58.5497 74.7395 55.7355 77.0235 53.8745C78.241 52.8826 79.0509 51.5649 79.801 50.1857C79.9925 49.8318 80.5495 45.549 77.3573 45.5613C74.5885 45.5718 71.4279 46.7354 69.1352 48.2809C66.5649 50.014 63.2286 53.0053 60.379 57.9732C59.4532 59.5889 57.7947 60.7139 55.9307 60.756C54.1721 60.7963 54.6271 59.9359 54.5182 56.312V51.0759V17.5236C54.5182 14.6199 52.1587 12.2665 49.2476 12.2665C46.3365 12.2665 43.977 14.6199 43.977 17.5236Z"
            fill="#FBCE9D"
        />
        <g clipPath="url(#clip0_488_641)">
            <path
                d="M49.0381 102C62.8452 102 74.0381 90.8071 74.0381 77C74.0381 63.1929 62.8452 52 49.0381 52C35.231 52 24.0381 63.1929 24.0381 77C24.0381 90.8071 35.231 102 49.0381 102Z"
                fill="#D75A4A"
            />
            <path
                d="M40.0381 86L49.0381 77L58.0381 68"
                stroke="white"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="M40.0381 68L49.0381 77L58.0381 86"
                stroke="white"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </g>
        <defs>
            <clipPath id="clip0_488_641">
                <rect
                    fill="white"
                    height="50"
                    transform="translate(24.0381 52)"
                    width="50"
                />
            </clipPath>
        </defs>
    </svg>
);
export const LeftArrowIcon = ({ color }) => (
    <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18 10H2M2 10L8 16M2 10L8 4"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);
export const RightArrowIcon = ({ color }) => (
    <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 10H18.5M18.5 10L12.125 3.625M18.5 10L12.125 16.375"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);
export const DotsIcon = () => (
    <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="2" cy="10" fill="black" r="2" />
        <circle cx="10" cy="10" fill="black" r="2" />
        <circle cx="18" cy="10" fill="black" r="2" />
    </svg>
);
export const BookIcon = () => (
    <svg
        fill="none"
        height="151"
        viewBox="0 0 150 151"
        width="150"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56.8965 129.988C51.1836 129.988 46.5518 134.62 46.5518 140.332C46.5518 146.045 51.1836 150.677 56.8965 150.677H150V129.987H56.8965V129.988Z"
            fill="#B12621"
        />
        <path
            d="M56.8968 0.677429C51.1839 0.677429 46.5521 5.30927 46.5521 11.0222V68.6661C54.2539 66.5998 62.4134 64.5308 68.7649 62.9506C76.0013 61.1506 81.7786 69.1832 77.6744 75.4108C75.7865 78.2763 72.9339 80.49 69.4865 81.5506L56.8941 85.4274C50.7468 87.3179 46.5518 92.9971 46.5518 99.4293V120.135V140.333C46.5518 134.62 51.1836 129.988 56.8965 129.988H150V0.677429H56.8968Z"
            fill="#DD342E"
        />
        <path
            d="M67.2412 52.4016H129.31V11.0222H67.2412V52.4016Z"
            fill="#EDEBDA"
        />
        <path
            d="M106.035 29.1256H90.518C89.0903 29.1256 87.9316 27.9669 87.9316 26.5393C87.9316 25.1116 89.0903 23.9529 90.518 23.9529H106.035C107.463 23.9529 108.622 25.1116 108.622 26.5393C108.622 27.9672 107.463 29.1256 106.035 29.1256Z"
            fill="#CEC9AE"
        />
        <path
            d="M113.794 39.4706H82.7592C81.3315 39.4706 80.1729 38.3119 80.1729 36.8843C80.1729 35.4567 81.3315 34.298 82.7592 34.298H113.794C115.221 34.298 116.38 35.4567 116.38 36.8843C116.38 38.3119 115.221 39.4706 113.794 39.4706Z"
            fill="#CEC9AE"
        />
        <path
            d="M137.069 142.919H59.4828C58.0552 142.919 56.8965 141.76 56.8965 140.332C56.8965 138.905 58.0552 137.746 59.4828 137.746H137.069C138.497 137.746 139.655 138.905 139.655 140.332C139.655 141.76 138.497 142.919 137.069 142.919Z"
            fill="#DD342E"
        />
        <path
            d="M68.7724 62.9485C60.5766 64.9864 45.8326 69.2122 37.8981 71.5141C34.3394 72.5459 31.011 74.2451 28.0913 76.5235C26.6095 77.6822 25.0163 78.6909 23.3405 79.5417C19.6553 81.4091 16.8697 84.6701 15.5845 88.5935C14.6742 91.3685 14.5087 91.5727 13.5776 91.8807L0 96.3675V124.816H3.42686C10.1716 124.816 20.8655 126.771 27.3442 128.656C30.3519 129.53 33.5019 129.988 36.6984 129.988H46.5519V99.4296C46.5519 92.9977 50.7466 87.3183 56.8942 85.4254L69.4866 81.5512C72.9392 80.4883 75.7942 78.272 77.6824 75.3985C81.7758 69.1762 76.0034 61.1512 68.7724 62.9485Z"
            fill="#FABA81"
        />
        <path
            d="M65.948 73.0911C70.9473 73.0911 74.9999 70.1971 74.9999 66.6256C74.9999 65.3661 74.4749 64.1998 73.6007 63.204C72.1499 62.6661 70.5025 62.5187 68.7644 62.9506C65.2651 63.8195 61.2125 64.8411 56.9946 65.9274C56.9583 66.16 56.8965 66.385 56.8965 66.6256C56.8965 70.1971 60.9491 73.0911 65.948 73.0911Z"
            fill="#EDEBDA"
        />
    </svg>
);
